/**
* QuizStartAndRunController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';QuizStartAndRunController.$inject = ["$state", "$location", "$http", "$rootScope"];

  angular.
  module('gplans.survey.controllers').
  controller('QuizStartAndRunController', QuizStartAndRunController);

  QuizStartAndRunController.$inject = ['$state', '$location', '$http', '$rootScope'];

  /**
                                                                                      * @namespace SelectMetaController
                                                                                      */
  function QuizStartAndRunController($state, $location, $http, $rootScope) {
    var vm = this;

    activate();

    /**
                * @name activate
                * @desc Actions to be performed when this controller is instantiated
                * @memberOf gplans.survey.controllers.QuizStartAndRunController
                */
    function activate() {
      // save affilate vars if we have any
      $http({
        url: gplansConf.API_URL + '/',
        method: "GET",
        params: $location.search() });

      // TODO: super temp solution, kill it ASAP!
      if (window.gplansStorage && !window.gplansStorage.offerId) {
        window.gplansStorage.offerId = 'CbMatt';
        $rootScope.offerId = 'CbMatt';
      }

      // Authentication.check();

      $state.go('survey.question', { surveyId: 1, question: 1 });
      fireHODirectLinkCode();
    }

    function fireHODirectLinkCode() {
      var hasoffers_domain = "https://goglianutrition.go2cloud.org",
      // create a <script> tag, like the one that's hard-coded now
      script = document.createElement("script"),
      // find whatever element contains the first <script> on the page -- usually <head> or <body>
      parent = document.getElementsByTagName("script")[0];

      script.src = "https://media.go2app.org/assets/js/dl.js";
      window.hasoffers_domain = hasoffers_domain;
      parent.appendChild(script);
    }
  }
})();